

export default {

  state:{
    preguntas:{
      doloresMusculares: [],
      comienzo:null,
      causas:[],
      tratamientos:[],
    },
    escalas:{
      artrosis: 0,
      muscular: 0,
    },
  },

  mutations: {

    setFisiatriaPreguntas(state, data){
      state.preguntas = data;
    },

    setFisiatriaEscalas(state, data){
      state.escalas = data;
    }
  }
}